export default __webpack_public_path__ + "static/golasimgSecond-2b4d3d6bcb81cb363462da7019e279e0.svg";